import React from 'react';
import Navbar from '../Homepage/Navbar';
import Footer from '../Homepage/Footer';
import NVCTICompleteSection from '../Homepage/Objective';
import Team from '../../components/Team';

const About = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-grow">
                <NVCTICompleteSection />
                <Team />
            </main>
            <Footer />
        </div>
    );
};

export default About;
